/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// node_modules
import React, { Component } from "react";

// components - atoms
import Button from "components/atoms/Button/Button.js";

// orchestration
import ERRORS from "orchestration/firebase-library/errors/Errors.js";
import ROUTING from "orchestration/Routing.js";

// utils
import LoggerUtils from "utils/logger-utils/LoggerUtils.js";
import SoundUtils from "utils/sound-utils/SoundUtils.js";
import RedirectUtils from "utils/redirect-utils/RedirectUtils.js";

class ErrorMessage extends Component {
  constructor(props) {
    super(props);
    // @props: className - String
    // @props: disableSound - Boolean
    // @props: style - Object {}
    // @props: textClassName - String
    // @props: textStyle - Object {}
    // @props: onClose - Function

    this.state = {};
  }

  render() {
    const { props } = this;
    const { children, className, style, textClassName, textStyle, onClose } = props;

    return (
      <div
        className={className || (
          "bg-white p-2 rounded kit-border-shadow " +
          "d-flex flex-column justify-content-center"
        )}
        style={{ maxWidth: "20rem", ...style }}
      >

        {/* Error Message */}
        <div
          className={textClassName || (
            "bg-light h5 rounded " +
            "align-items-center d-flex flex-column justify-content-center " +
            "text-break text-center text-danger text-wrap"
          )}
          style={{
            minHeight: "5rem",
            overflow: "auto",
            wordBreak: "break-word",
            ...textStyle
          }}
        >
          {children.hasOwnProperty("message")
            ? children.message
            : children
          }
          <span className={"h6 mt-1 text-dark"}>
            {ERRORS.appendedUserSuggestion}
          </span>
        </div>

        {/* Error Actions */}
        <div className={"d-flex justify-content-around"}>

          {/* Report a bug */}
          <Button
            className={"btn btn-secondary btn-sm"}
            style={{ width: "33%" }}
            onClick={() => RedirectUtils.redirect(
              `${ROUTING.info.root}${ROUTING.info.reportAnIssue}`
            )}
          >
            {"+ Report an issue"}
          </Button>

          {/* Ignore Error */}
          <Button
            className={"btn btn-primary btn-sm"}
            onClick={onClose}
            style={{ width: "33%" }}
          >
            {"Return to what I was doing"}
          </Button>

        </div>

      </div>
    );
  }

  componentDidMount() {
    const { props } = this;
    const { children, disableSound } = props;
    LoggerUtils.error(children);
    if (!disableSound) {
      SoundUtils.alert();
    }
  }
}
export default ErrorMessage;
